<template>
  <div>
    <q-list bordered>
      <div class="row">
        <q-item-label header>MQTT Messages</q-item-label>
        <q-space />
        <q-btn color="red" icon="delete" @click="clearHistory()" style="height: 15px; width: 15px;" >
        </q-btn>
      </div>

      <!-- <q-intersection
        v-for="(message, index) in list.slice().reverse()"
        :key="message"
        transition="scale"
        class="example-item"
      > -->
      <q-item clickable v-ripple v-for="(message, index) in list.slice().reverse()" :key="message">
        <q-item-section avatar>
          <q-btn dense color="primary" round icon="email" class="q-ml-md">
            <q-badge color="green" floating>{{ list.length - index }}</q-badge>
          </q-btn>
        </q-item-section>

        <q-item-section>
          <q-item-label lines="1">Topic: {{ message.topic }}</q-item-label>
          <q-item-label caption lines="2">
            {{ message.data }}
          </q-item-label>
        </q-item-section>

        <q-item-section side top>
          {{ calculateTimeElapsed(message.ts, new Date) }}
        </q-item-section>

        <q-separator inset="item" />

      </q-item>
      <!-- </q-intersection> -->
    </q-list>
  </div>
</template>

<style></style>

<script>
export default {
  name: 'MQTTMessages',
  data() {
    return {
      list: this.$store.state.messages.list,
    }
  },
  methods: {
    calculateTimeElapsed(startTime, endTime) {
      startTime = new Date(startTime);
      endTime = new Date(endTime);
      const timeDiff = endTime - startTime;

      let days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
      if (days > 0) {
        return days + " days ago"
      }
      let hours = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      if (hours > 0) {
        return hours + " hours ago"
      }
      let minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
      if (minutes > 0) {
        return minutes + " minutes ago"
      }
      let seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);
      if (seconds < 0) {
        return 0 + " seconds ago"
      }
      return seconds + " seconds ago"
    },
    clearHistory() {
      this.$store.commit('clearMessages');
      this.list = this.$store.state.messages.list;
    }

  }
}


</script>
